<table class="estimates_table simple-table">
  <thead>
    <tr>
      <th style="width:30px;"></th>
      @if (type==='targets') {
        <th>Type</th>
      }
      <th>Name</th>
      <th>Current Value</th>
      <th>Positive Variance</th>
    </tr>
  </thead>
  <tbody style="text-align: center;">
    @for (sd_series of series_data; track sd_series; let i = $index) {
      @if (!isUnsaved(sd_series)) {
        <tr>
          <td style="width:30px;text-align:center;padding:0 2px;">
            @if (type==='targets') {
              <button style="background:transparent;border:none;"
                (click)="updateTargetSeries(sd_series)" [disabled]="isUnsaved(sd_series)">
                <i class="fa fa-edit"></i>
              </button>
            }
            @if (type!=='targets') {
              <button style="background:transparent;border:none;"
                (click)="updateSourceSeries(sd_series)" [disabled]="isUnsaved(sd_series)">
                <i class="fa fa-edit"></i>
              </button>
            }
          </td>
          @if (type==='targets') {
            <td [dblClickCopy]="sd_series.attributes.series_type_name">{{sd_series.attributes.series_type_name}} </td>
          }
          <td title="{{sd_series.attributes.name}}">
            <span [dblClickCopy]="sd_series.attributes.name">{{sd_series.attributes | nameAndDescription}}</span>
          </td>
          <td style="text-align: center;" [dblClickCopy]="sd_series.current_value">{{sd_series.current_value}}</td>
          <td style="text-align: center;">
            <mat-checkbox [ngModel]="getPositiveVariance(sd_series)"
              (ngModelChange)="setPositiveVariance(sd_series, $event)"
              [disabled]="isUnsaved(sd_series)"
            matTooltip="Show positive variance (actual is less than target) as favourable"></mat-checkbox>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
